// React
import { useEffect, useState } from 'react'

// Models
import { RootStore, RootStoreProvider, setupRootStore } from './models'

// Route
import { EntryPoint } from './EntryPoint'

// Antd
import { ConfigProvider } from 'antd'

// React Router Dom
import { BrowserRouter } from 'react-router-dom'

// Locale
import 'moment/locale/id'
import localeId from 'antd/lib/locale/id_ID'

// Components
import { BaseOverlayLoader } from 'components'

const App = () => {
  const [rootStore, setRootStore] = useState<RootStore | undefined>(undefined)

  // Initialize the store
  useEffect(() => {
    setupRootStore().then(setRootStore)

    // eslint-disable-next-line
  }, [])

  if (!rootStore) return null

  if (rootStore) rootStore?.localization.localization_setLanguage(rootStore.localization.localization_lang)

  return (
    <RootStoreProvider value={rootStore}>
      <ConfigProvider locale={localeId}>
        {/* Router */}
        <BrowserRouter>
          {/* Overlay Loader */}
          <BaseOverlayLoader isLazyLoading={false} />

          {/* Entry Point of The App */}
          <EntryPoint />
        </BrowserRouter>
      </ConfigProvider>
    </RootStoreProvider>
  )
}

export { App }
